import { setupNavigation, closeNavigation } from "./navigation";
import { setupFilters } from "./filters";
import { initializePreferenceSelector } from "./preference_selector";
import setupTextAreas from "./textarea_counter";

function initializeSc() {
  setupNavigation();
  setupAuteurActiviteitenSwiper();
  setupQuotesSwiper();
  setupHeroSwiper();
  setupAccordion();
  setupMasonryGrid();
  setupFilters();
  initializePreferenceSelector();
  setupTextAreas();
  setupTags();
}

function setupMasonryGrid() {
  const $grid = $("#masonry-grid");
  if (!$grid.length) return;

  if ($grid.data("masonry")) {
    $grid.masonry("destroy");
  }

  // Initialize masonry first, before images load
  $grid.masonry({
    itemSelector: ".grid-item",
    percentPosition: true,
    columnWidth: ".grid-sizer",
    gutter: 0,
  });

  // Re-layout as each image loads, not just when all are done
  $grid.imagesLoaded().progress(function () {
    $grid.masonry("layout");
  });

  $(window)
    .off("resize.masonry")
    .on("resize.masonry", function () {
      $grid.masonry("layout");
    });
}

function setupAuteurActiviteitenSwiper() {
  const swiperContainers = document.querySelectorAll('.swiper-menu');
  const swipers = [];

  swiperContainers.forEach((container) => {
    const prev = container.querySelector('.swiper-button-prev');
    const next = container.querySelector('.swiper-button-next');

    const swiper = new Swiper(container, {
      speed: 200,
      slidesPerView: 'auto',
      spaceBetween: 16,
      simulateTouch: false,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });

    swipers.push(swiper);
  });

  document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tabButton) => {
    tabButton.addEventListener('shown.bs.tab', (event) => {
      const targetId = event.target.getAttribute('data-bs-target');
      const targetPane = document.querySelector(targetId);
      if (!targetPane) return;
      const container = targetPane.querySelector('.swiper-menu');
      const swiperIndex = Array.from(swiperContainers).indexOf(container);
      if (swiperIndex !== -1 && swipers[swiperIndex]) {
        swipers[swiperIndex].update();
        swipers[swiperIndex].slideTo(0, 0);
      }
    });
  });
}

function setupQuotesSwiper() {
  const swiper_quotes = new Swiper(".swiper__quotes", {
    speed: 700,
    autoHeight: false,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
  });
}

function setupHeroSwiper() {
  const instance = new Swiper(".swiper-hero", {
    speed: 200,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: false,
    simulateTouch: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

function setupAccordion() {
  const selectors = {
    accordionHead: ".accordion-item .accordion-item-head",
  };
  // Vanilla JS accordion implementatie
  const accordionHeaders = document.querySelectorAll(".accordion-header");
  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const currentHeader = header;
      const currentContent = header.nextElementSibling;

      accordionHeaders.forEach((otherHeader) => {
        const otherContent = otherHeader.nextElementSibling;
        if (otherHeader !== currentHeader) {
          otherContent.classList.remove("active");
          otherHeader.classList.remove("active");
        }
      });

      currentContent.classList.toggle("active");
      currentHeader.classList.toggle("active");
    });
  });

  // jQuery handler voor legacy code
  $(document).on("click", selectors.accordionHead, function () {
    $(this).parent().toggleClass("is-active");
  });
}

function setupTags() {
  Tags.init();
}

document.addEventListener("turbo:load", initializeSc);
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("select[multiple]").forEach((el) => {
    const instance = Tags.getInstance(el);
    if (instance) {
      instance.dispose();
    }
  });
  closeNavigation();
});
